import { administrationRequests } from "api/administrationApi";
import ScheduledItemsGrid from "./ScheduledItemsGrid";

const PracticesGrid = props => (
  <ScheduledItemsGrid
    {...props}
    source="practiceId"
    reference={administrationRequests.getPracticesSelect()}
    label="Учебна практика"
  />
);

export default PracticesGrid;
